import { observable, action } from 'mobx';
import agent from '../../api/agent';
import navigatorStore from '../navigatorStore'
export default new class ArtistListStore {
    @observable paginationLimit = 25;
    @observable paginationOffset=0;

    @action getInitialResultsArtists(query){
        return agent.Artists.getAllArtistsCategory(query,{limit : 4 ,offset : parseInt(0) })
        .catch(action(err => {
            // this.commentErrors = err.response && err.response.body && err.response.body.errors;
              navigatorStore.openErrorModal(err);
          }))
    }
    @action getInitialResultsArtistsPublic(query){
        return agent.Artists.getArtistsCategoryPublic(query,{limit : 4 ,offset : parseInt(0) })
        .catch(action(err => {
            // this.commentErrors = err.response && err.response.body && err.response.body.errors;
              navigatorStore.openErrorModal("Something went wrong. Please try again.");
          }))
    }


    @action getAllArtists(query){
        // console.log(this.paginationOffset)
        // let queryString = querystring.stringify({limit : this.paginationLimit ,offset : this.paginationOffset });
        return agent.Artists.getAllArtists(query,{limit : 4 ,offset : 0 })
        .catch(action(err => {
            // this.commentErrors = err.response && err.response.body && err.response.body.errors;
        navigatorStore.openErrorModal("Something went wrong. Please try again.");
          }))
    }
    @action loadmore(){
        // console.log("came here")
        this.paginationOffset = this.paginationOffset +25;
        this.paginationLimit = this.paginationLimit +25;
        // console.log(this.paginationOffset)
        // this.getAllArtworks()
    }

}


// WEBPACK FOOTER //
// ./src/stores/artistsStore/artistsListStore.js